<div class="container-fluid main-container my-5">
  <div class="pt-3">
    <h1 class="subtitle mt-4">Word een Held met Stichting Steddie!</h1>
    <hr class="horizontal-ruler">
    <div class="row">
      <div class="col-lg-8">
        <p class="info-text mt-2">
          Ben jij klaar om een verschil te maken? Sluit je vandaag nog aan bij onze missie om
          'Meedoen mogelijk te maken' voor iedereen! <br />
          Stichting Steddie is op zoek naar helden zoals jij, die bereid zijn om hun steentje bij te dragen. Of je
          nu financieel bijdraagt of op een andere manier ondersteunt, jouw inzet maakt een directe impact op
          gemeenschappen in Nederland. <br />
          <br />
          Door een Held van Steddie te worden, help je kwetsbare groepen en individuen om actief deel te
          nemen aan de samenleving. Jouw steun betekent meer dan alleen een donatie; het opent de deuren
          naar kansen, inclusie en hoop voor velen.
          Met jouw steun maken wij dit namelijk mogelijk! <br />
          <br />
          Dus waar wacht je nog op? Sluit je aan bij ons Heldenteam en maak samen met Stichting Steddie een
          blijvend verschil. Of je nu eenmalig doneert of regelmatig bijdraagt, jouw bijdrage telt. <br />
          <br />
          Word vandaag nog een Held met Stichting Steddie en help mee om meedoen voor iedereen mogelijk te maken!
        </p>
        <b>Iedere Held wordt (uiteraard alleen als je dat zelf wilt) vermeld op deze pagina.</b>
      </div>
      <div class="col-lg-4 hero-img">
        <img src="assets/img/Steddie-Held.png">
      </div>
    </div>
    <table class="support-details">
      <tr>
        <td class="support-text">Donaties tot 100 euro:</td>
        <td><b>Held</b></td>
      </tr>
      <tr>
        <td class="support-text">Donaties van 100 tot 500 euro:</td>
        <td><b>Grote Held</b></td>
      </tr>
      <tr>
        <td class="support-text">Donaties vanaf 500 euro:</td>
        <td><b>Superheld</b></td>
      </tr>
    </table>
    <b>Geef.nl</b>
    <p class="info-text">
      Op de website van Geef.nl kun je heel eenvoudig jouw donatie aan Stichting Steddie overmaken. Elke bijdrage is welkom!
    </p>
    <a target="_blank" href="https://www.geef.nl/nl/doneer?charity=11000"><img src="assets/img/doneer-nu.png" alt="Foto met daarop 'Doneer nu'" class="footer-image" width="250"></a>
    <br /><br />
    <p>Oh ja, Stichting Steddie is een
      <a target="_blank" href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/zakelijk/bijzondere_regelingen/goede_doelen/algemeen_nut_beogende_instellingen/aan_welke_voorwaarden_moet_een_anbi_voldoen/aan_welke_voorwaarden_moet_een_anbi_voldoen">
        Algemeen Nut Beogende Instelling (ANBI)
      </a>
      en daarmee erkend als goed doel. Jouw donatie is daarom
      <a target="_blank" href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/inkomstenbelasting/aftrekposten/persoonsgebonden-aftrek/giften_aan_goede_doelen/giften">
        aftrekbaar
      </a>
      van de belastingen.
      Dit maakt het daarom nog eens extra aantrekkelijk om Stichting Steddie te steunen.</p>
    <b>Stichting Steddie</b>
    <p class="info-text pb-1">
      KvK-nummer 88994783 <br />
      RSIN: 864847555
    </p>
  </div>
</div>
